/* Koji Cards – menu mobile.
   1) Encaixa a parte de baixo (snippets/koji-drawer-extras.liquid) na gaveta do tema.
   2) Coloca "Buscar" nos campos de busca (a traducao do tema esta vazia). */
(function () {
  function mount() {
    var template = document.getElementById('koji-drawer-extras');
    var inner = document.querySelector('#header-menu .drawer__inner');
    if (template && inner && !inner.querySelector('.koji-drawer__extras')) {
      inner.appendChild(template.content.cloneNode(true));
    }

    var inputs = document.querySelectorAll('input[type="search"][data-predictive-search-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (!inputs[i].placeholder) {
        inputs[i].placeholder = 'Buscar';
        inputs[i].setAttribute('aria-label', 'Buscar');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
